export default __webpack_public_path__ + "static/media/categoria.d9de1fb3.png";